import { createGlobalStyle } from 'styled-components';
import { Theme } from './theme';

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}

export const GlobalStyles = createGlobalStyle`
  :root {
    --font-sans: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Roboto Mono', 'Courier New', monospace;
    // --min-font: 14px;
    // --max-font: 20px;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  html {
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    touch-action: manipulation;
    text-rendering: optimizeLegibility;
    font-family: var(--font-sans);
    line-height: 1.5;
    height: 100%;
    // font-size: clamp(var(--min-font), 1.4vw + 1vh, var(--max-font));
  }

  body {
    margin: 0;
    padding: 0;
    min-height: 100%;
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.onBackground};
    font-family: var(--font-sans);
    font-size: ${({ theme }) => theme.fontSizes.base};
    line-height: 1.5;
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: transparent;
    overflow-x: hidden;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    line-height: 1.25;
  }

  h1 { font-size: ${({ theme }) => theme.fontSizes['4xl']}; }
  h2 { font-size: ${({ theme }) => theme.fontSizes['3xl']}; }
  h3 { font-size: ${({ theme }) => theme.fontSizes['2xl']}; }
  h4 { font-size: ${({ theme }) => theme.fontSizes.xl}; }
  h5 { font-size: ${({ theme }) => theme.fontSizes.lg}; }
  h6 { font-size: ${({ theme }) => theme.fontSizes.base}; }

  p {
    margin: 0 0 ${({ theme }) => theme.spacing.md};
  }

  /* Links */
  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover, &:focus {
      color: ${({ theme }) => theme.colors.primaryDark};
      outline: none;
    }
  }

  /* Buttons and interactive elements */
  button, input, optgroup, select, textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }

  button, input {
    overflow: visible;
  }

  button, [type="button"], [type="reset"], [type="submit"] {
    -webkit-appearance: button;
  }

  /* Remove the inner border and padding in Firefox */
  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /* Utility classes */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  /* iOS specific fixes */
  @supports (-webkit-touch-callout: none) {
    input, textarea {
      font-size: 16px; /* Prevent iOS zoom on focus */
    }
  }

  /* react-pdf adjustments */
  .react-pdf__Document {
    display: inline-block;
  }

  .react-pdf__Page {
    width: 300px;
    height: 424px;
  }

  /* Skeleton shimmer for loading placeholders */
  @keyframes skeleton-shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  .skeleton {
    position: relative;
    background: linear-gradient(90deg, rgba(148,163,184,0.12) 25%, rgba(148,163,184,0.24) 37%, rgba(148,163,184,0.12) 63%);
    background-size: 400% 100%;
    animation: skeleton-shimmer 1.4s ease-in-out infinite;
    border-radius: 8px;
  }

  @media (max-width: 768px) {
    /* On small screens, treat the HTMLFlipBook root as a flex container
       and center its contents. This keeps the page stage visually
       centered in mobile portrait view without overriding the
       internal StPageFlip transforms. */
    .flipbook {
      // display: flex !important;
      // align-items: center !important;
      // justify-content: center !important;
      min-width: unset !important;
      min-height: 50vh !important;
    }
  }

`;
